import React from "react";
import { Container, Grid, Box, Typography, Button } from "@mui/material";
import "../styles/Section1.css";
import tele1 from "../assets/Images/tele1.png";
import VerifiedUserRoundedIcon from "@mui/icons-material/VerifiedUserRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const DoctorSection = () => {
  return (
    <Box className="doctor-section-wrap" id="doctors">
      <Container maxWidth="xl">
        <Grid container spacing={6} alignItems="center">
          {/* Left: Content for Medical Experts */}
          <Grid item xs={12} md={6}>
            <Box sx={{ maxWidth: "560px" }}>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  bgcolor: "rgba(19, 91, 236, 0.25)",
                  border: "1px solid rgba(19, 91, 236, 0.4)",
                  color: "#93C5FD",
                  fontSize: "13.5px",
                  fontWeight: 700,
                  px: 2,
                  py: 0.7,
                  borderRadius: "999px",
                  mb: 2.5,
                }}
              >
                <VerifiedUserRoundedIcon sx={{ fontSize: 16 }} />
                <span>For Medical Professionals</span>
              </Box>

              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: "32px", md: "42px" },
                  fontWeight: 800,
                  color: "#FFFFFF",
                  letterSpacing: "-0.5px",
                  lineHeight: 1.2,
                  mb: 2.5,
                }}
              >
                Practice Medicine On Your Terms. Reach Patients Nationwide.
              </Typography>

              <Typography
                sx={{
                  fontSize: "17px",
                  color: "#CBD5E1",
                  lineHeight: 1.65,
                  mb: 4,
                }}
              >
                Join our network of verified physicians, specialists, and clinical experts.
                Verify your credentials securely via NIN, set your consultation availability,
                and earn competitive fees paid directly to your wallet.
              </Typography>

              <Grid container spacing={2.5} sx={{ mb: 4 }}>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      p: 2.5,
                      borderRadius: "14px",
                      bgcolor: "rgba(255, 255, 255, 0.06)",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                    }}
                  >
                    <EventAvailableRoundedIcon sx={{ color: "#60A5FA", fontSize: 28, mb: 1 }} />
                    <Typography sx={{ color: "#FFFFFF", fontWeight: 700, fontSize: "16px", mb: 0.5 }}>
                      Flexible Scheduling
                    </Typography>
                    <Typography sx={{ color: "#94A3B8", fontSize: "13.5px", lineHeight: 1.5 }}>
                      Set your own available hours for video and audio consultations.
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      p: 2.5,
                      borderRadius: "14px",
                      bgcolor: "rgba(255, 255, 255, 0.06)",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                    }}
                  >
                    <PaymentsRoundedIcon sx={{ color: "#34D399", fontSize: 28, mb: 1 }} />
                    <Typography sx={{ color: "#FFFFFF", fontWeight: 700, fontSize: "16px", mb: 0.5 }}>
                      Instant Earnings
                    </Typography>
                    <Typography sx={{ color: "#94A3B8", fontSize: "13.5px", lineHeight: 1.5 }}>
                      Earn ₦15,000 to ₦20,000 per consultation, with fast bank transfers.
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#135BEC",
                    color: "#FFFFFF",
                    fontWeight: 700,
                    fontSize: "15px",
                    px: 3.5,
                    py: 1.4,
                    borderRadius: "12px",
                    textTransform: "none",
                    boxShadow: "0 6px 20px rgba(19, 91, 236, 0.4)",
                    "&:hover": {
                      bgcolor: "#0D4BCA",
                    },
                  }}
                >
                  Apply as a Medical Expert
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<LockOutlinedIcon />}
                  sx={{
                    borderColor: "rgba(255, 255, 255, 0.2)",
                    color: "#FFFFFF",
                    fontWeight: 700,
                    fontSize: "15px",
                    px: 3,
                    py: 1.4,
                    borderRadius: "12px",
                    textTransform: "none",
                    "&:hover": {
                      borderColor: "#FFFFFF",
                      bgcolor: "rgba(255, 255, 255, 0.08)",
                    },
                  }}
                >
                  Doctor Login
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* Right: Phone Mockup showcasing tele1.png */}
          <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                position: "relative",
                maxWidth: "340px",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  background: "radial-gradient(circle, rgba(19, 91, 236, 0.35) 0%, rgba(19, 91, 236, 0) 70%)",
                  filter: "blur(35px)",
                  zIndex: 0,
                }}
              />
              <img
                src={tele1}
                alt="Telemedicine Medical Expert Login Mockup"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  position: "relative",
                  zIndex: 1,
                  filter: "drop-shadow(0 25px 45px rgba(0, 0, 0, 0.4))",
                  borderRadius: "32px",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default DoctorSection;
